<script setup>
import { ref, watch, nextTick } from 'vue';
import FilterButton from 'dashboard/components/ui/Dropdown/DropdownButton.vue';
import FilterListDropdown from 'dashboard/components/ui/Dropdown/DropdownList.vue';

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  id: {
    type: [Number, null],
    default: null,
  },
  type: {
    type: String,
    required: true,
  },
  options: {
    type: Array,
    default: () => [],
  },
  activeFilterType: {
    type: String,
    default: '',
  },
  showMenu: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: '',
  },
  enableSearch: {
    type: Boolean,
    default: false,
  },
  showClearFilter: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits([
  'toggleDropdown',
  'removeFilter',
  'addFilter',
  'closeDropdown',
]);
const toggleDropdown = () => emit('toggleDropdown', props.type);
const removeFilter = () => emit('removeFilter', props.type);
const addFilter = item => emit('addFilter', item);
const closeDropdown = () => emit('closeDropdown');

const triggerEl = ref(null);
const dropdownPos = ref({ top: 0, left: 0 });

function updatePos() {
  const el = triggerEl.value?.$el ?? triggerEl.value;
  if (!el) return;
  const rect = el.getBoundingClientRect();
  dropdownPos.value = { top: rect.bottom + 4, left: rect.left };
}

watch(
  () => props.showMenu && props.activeFilterType === props.type,
  isOpen => {
    if (isOpen) nextTick(updatePos);
  }
);
</script>

<template>
  <FilterButton
    ref="triggerEl"
    trailing-icon
    icon="i-lucide-chevron-down"
    :button-text="name"
    @click="toggleDropdown"
  >
    <template v-if="showMenu && activeFilterType === type" #dropdown>
      <Teleport to="body">
        <FilterListDropdown
          v-if="options"
          v-on-clickaway="closeDropdown"
          :show-clear-filter="showClearFilter"
          :list-items="options"
          :active-filter-id="id"
          :input-placeholder="placeholder"
          :enable-search="enableSearch"
          class="!fixed flex flex-col w-[240px] overflow-y-auto"
          :style="{
            top: dropdownPos.top + 'px',
            left: dropdownPos.left + 'px',
          }"
          @select="addFilter"
          @remove-filter="removeFilter"
        />
      </Teleport>
    </template>
  </FilterButton>
</template>
